import { render, staticRenderFns } from "./MainButtonGroup.vue?vue&type=template&id=2acf2ddf&"
import script from "./MainButtonGroup.vue?vue&type=script&lang=js&"
export * from "./MainButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports